export const getInitialStringValue = (
  value: number | string | undefined | null
) => {
  if (!value) {
    return '';
  }
  return `${value}`;
};

export const evaluateInitialValue = (
  input: string | boolean | undefined | null | number
) => {
  return input === false ? false : input || input === 0 ? input : '';
};
